import MediaQuery from './MediaQuery'

export default class MetaNavigationScroll {
    constructor(languageNavigation) {
        this.languageNavigation = languageNavigation
        this.previousScrollPosition = window.scrollY
        this.distanceInSameDirection = 0
        this.hasPreviouslyScrolledDown = true
        this.isMetaNavigationVisible = true
        this.header = document.querySelector('.js__header')
        document.addEventListener('scroll', () => this.onScroll())
    }

    onScroll() {
        if (MediaQuery.UpMd.matches) {
            this.calculateScrollInformation()
            this.setMetaNavigationVisibility()
        }
    }

    /**
     * Calculate the scroll direction, and the distance one has scrolled in the same direction to make the hide/show
     * less "nervous".
     */
    calculateScrollInformation() {
        const isCurrentScrollDirectionDown = this.previousScrollPosition < window.scrollY

        if (isCurrentScrollDirectionDown) {
            if (this.hasPreviouslyScrolledDown) {
                this.distanceInSameDirection += window.scrollY - this.previousScrollPosition
            } else {
                this.distanceInSameDirection = 0
            }
            this.hasPreviouslyScrolledDown = true
        } else {
            if (!this.hasPreviouslyScrolledDown) {
                this.distanceInSameDirection += this.previousScrollPosition - window.scrollY
            } else {
                this.distanceInSameDirection = 0
            }
            this.hasPreviouslyScrolledDown = false
        }
        this.previousScrollPosition = window.scrollY
    }

    /**
     * Decide on the visibility state
     */
    setMetaNavigationVisibility() {
        // safety measure to always ensure the meta navigation is visible if scrolled to the very top
        if (window.scrollY === 0) {
            this.showMetaNavigation()
            return
        }

        // early return if the threshold hasn't been reached yet
        const isScrollThresholdReached = this.distanceInSameDirection > 300
        if (!isScrollThresholdReached) {
            return
        }

        if (this.hasPreviouslyScrolledDown) {
            this.hideMetaNavigation()
        } else {
            this.showMetaNavigation()
        }
    }

    showMetaNavigation() {
        // early return if meta navigation already is visible
        if (this.isMetaNavigationVisible) {
            return
        }
        this.isMetaNavigationVisible = true
        document.body.classList.remove('header--hidden')
        window.dispatchEvent(new Event('header-meta-shown'))
    }

    hideMetaNavigation() {
        // early return if meta navigation already is hidden
        if (!this.isMetaNavigationVisible) {
            return
        }
        this.isMetaNavigationVisible = false
        this.languageNavigation.hideDropdown()
        document.body.classList.add('header--hidden')
        window.dispatchEvent(new Event('header-meta-hidden'))
    }
}
